import { store } from "../../../store/store";

import { getDealDataForCart } from "../inventory/DealsUtils";
import { isObjectEmpty, isObjectNotEmpty, vibrateDevice } from "../CommonUtils";
import { trackMoengageEvents, MoengageEvents } from "../webapp-services/MoengageUtils";
import { updateOrderInstructions, updateRepeatOrderDataToRedux } from "../redux/commonRedux";
import { getCartTotalItemCount, updateCartImagesToRedux, updateCartItemsToRedux, upsertCartItemToRedux } from "./UpsertCartData";

import { OMSCartDataModel } from "../../models/OMSCartData";
import { MedicineDataVersion, OrderType } from "../../constants/AppConstants";

export const clearCartData = () => {
    updateCartItemsToRedux([])
    updateCartImagesToRedux([])
    updateOrderInstructions('')
}

export function clearRepeatOrderData() {
    updateRepeatOrderDataToRedux({})
}

export const getCartItemFroRedux = () => {
    let cartItems = []
    const reduxState: any = store.getState();
    if (typeof (reduxState.cartItemsData) == "object")
        cartItems = reduxState.cartItemsData ?? []
    else if (reduxState.cartItemsData &&
        reduxState.cartItemsData?.length > 2)
        cartItems = JSON.parse(reduxState.cartItemsData) ?? [];
    cartItems.forEach((item) => item.quantity = item.quantity ?? 1)
    return cartItems
}

export const getCartMedicinesList = () => {
    let cartItems = getCartItemFroRedux()
    let cartMedicines = cartItems ? cartItems.filter((item: any) =>
        !item.hasOwnProperty('dealId')) : []
    return cartMedicines
}

export const getCartImagesFromRedux = () => {
    let cartImages = [];
    const reduxState: any = store.getState();
    if (typeof (reduxState.cartImagesData) == "object")
        cartImages = reduxState.cartImagesData ?? []
    else if (reduxState.cartImagesData &&
        reduxState.cartImagesData?.length) {
        cartImages = JSON.parse(reduxState.cartImagesData)
    }
    return cartImages
}

export const getOrderInstruction = () => {
    let orderInstructions = ''
    const reduxState: any = store.getState();
    if (reduxState.orderInstructions)
        orderInstructions = reduxState.orderInstructions
    return orderInstructions
}

export const calculateCartAmount = (cartList) => {
    let amount = 0;
    cartList && cartList.length && cartList?.forEach(element => {
        if (element?.mrp)
            amount += ((element.mrp.price / element.mrp.su) * element.quantity)
    });
    return amount
}

export const mergeDealWithCartData = ({ deal: deal, cartItemsList = null }) => {
    if (!cartItemsList) cartItemsList = getCartItemFroRedux()
    if (!deal) return []
    if (cartItemsList.length) {
        let cartItem = {}
        cartItemsList.forEach((item, itemIndex) => {
            if (item?.dealId == deal?.dealId)
                cartItem = item
        })
        if (isObjectEmpty(cartItem)) {
            if (deal && deal['quantity']) delete deal['quantity']
        } else deal = cartItem;
    } else if (deal && deal['quantity']) delete deal['quantity']
    return deal
}

export const mergeDealListWithCartData = ({ deals: dealsList, cartItemsList = getCartItemFroRedux() }) => {
    let isDealListUpdated = false
    if (!dealsList) return {
        isDealListUpdated: isDealListUpdated, dealsList: dealsList ?? []
    }
    if (cartItemsList.length) {
        dealsList.forEach((deal) => {
            let dealData = getDealDataForCart(deal)
            let cartItemQuantity = 0
            cartItemsList.forEach((item) => {
                if (item?.dealId || item?.mmid) {
                    if (item?.dealId && item?.dealId == dealData?.dealId)
                        cartItemQuantity = item.quantity
                    else if (item?.mmid && item?.mmid == dealData?.mmid)
                        cartItemQuantity = item.quantity
                } else if (item?.name && item?.name == dealData.name)
                    cartItemQuantity = item.quantity
            })
            // Currently not removing cart deals item if doesn't exist in deals list.
            if (cartItemQuantity) {
                isDealListUpdated = true
                deal['quantity'] = cartItemQuantity;
            } else if (deal && deal?.quantity && deal['quantity'] > 0) {
                isDealListUpdated = true
                delete deal['quantity']
            }
        })

    } else dealsList.forEach((product: any, index) => {
        if (product && product['quantity']) delete product['quantity']
    })
    return { isDealListUpdated: isDealListUpdated, dealsList: dealsList }
}

export const mergeMedicineWithCartData = ({ medicines: medicinesList,
    cartItemsList = getCartItemFroRedux(),
    retainTypeMedicine = false, typeMedicineName = '' }) => {
    if (cartItemsList.length) {
        if (medicinesList.length) {
            medicinesList.forEach((med) => {
                let cartItemQuantity = 0
                cartItemsList.forEach((item) => {
                    if (!item.hasOwnProperty('dealId') &&
                        item?.mmid == med?.mmid)
                        cartItemQuantity = item.quantity
                })
                if (cartItemQuantity) {
                    med['quantity'] = cartItemQuantity;
                } else if (med && med['quantity']) delete med['quantity']
            })
        } else if (retainTypeMedicine) {
            let typeMedicineList = cartItemsList.filter((item) => {
                var isTypedMedicine = !item.hasOwnProperty('mmid') &&
                    !item.hasOwnProperty('dealId') && !item.hasOwnProperty('spid')
                if (typeMedicineName && typeMedicineName != item.name)
                    isTypedMedicine = false
                return isTypedMedicine

            })
            medicinesList = typeMedicineList
        }
    } else medicinesList.forEach((med: any) => {
        if (med && med['quantity']) delete med['quantity']
    })
    return medicinesList

}

export const countCartItems = (cartItems, cartImages) => {
    let itemCount = (cartItems?.length ?? 0) +
        (cartImages?.length ?? 0);
    return itemCount;
}

export const checkIfSearchMedsExists = (cartItems) => {
    if (cartItems?.length) {
        // Check for profuct as custom search medicine also exist
        let deals = cartItems.filter((item) =>
            item.hasOwnProperty('dealId'));
        if (deals.length && deals.length == cartItems.length)
            return false
        else return true
    } else return false
}


export const prepareCartData = (cartItems, cartImages, instructions) => {
    let cartData = new OMSCartDataModel([], [], [], '')
    if (cartItems && cartItems?.length) {
        let medicines = []
        let products = []
        cartItems.forEach((data: any) => {
            if (data.hasOwnProperty('dealId'))
                products.push(data)
            else medicines.push(data)
        })
        cartData.medications = medicines
        cartData.products = products
    }
    if (cartImages && cartImages.length)
        cartData.imageList = cartImages
    cartData.note = instructions ?? ''
    return cartData
}

export const getOrderType = (cartData) => {
    return cartData.imageList.length > 0 ? OrderType.precriptions :
        cartData.medications.length ? OrderType.medicines :
            OrderType.products;
}

export const getOrderSavingsAmount = (cartData) => {
    if (cartData.length > 0) {
        let savingsAmount = 0
        cartData.forEach((item) => {
            if (!item.mmid)
                savingsAmount = savingsAmount + item.saving * item.quantity
        })
        return savingsAmount;
    } else return 0;
}

export const removeCartItemSearchByMedicine = () => {
    let cartItems = getCartItemFroRedux()
    let dealsCart = cartItems ? cartItems.filter((item: any) =>
        item.hasOwnProperty('dealId')) : []
    updateCartItemsToRedux(dealsCart);
}

export const assignCustomItemToMedicineData = (customItem, { assignmmid = true }) => {
    var customData = Object.assign(customItem, {
        omg: false, selected: false,
        su: 0, uip: 0, uPrice: 0, estimatePrice: 0,
        dfPlural: "", dfSingular: "", packSizeLabel: "",
        mid: 1, medicineDataVersion: MedicineDataVersion,

        form: "", meta: "", salt: "", drugCls: "", packing: "",
        packForm: "", category: "", companyName: "", dosagePerDay: 0,
    })
    if (assignmmid) customData['mmid'] = null
    return customData
}

export const getImageUrlMap = (imageUrl, thumbnailUrl, imageToken = '') => {
    return { imageURL: imageUrl, thumbnailUrl: thumbnailUrl, token: imageToken }
}

export const mapImageUrlToList = (orderPrescriptionImages, imageTokenList = []) => {
    var presImagesList = orderPrescriptionImages.map((image, index) => {
        return getImageUrlMap(image['redirectUrl'],
            image['thumbnailUrl'], imageTokenList[index] ?? '')
    })
    return presImagesList
}

export function mergeRepeatOrderItemWithCart(repeatOrderMeds) {
    let cartItems = getCartItemFroRedux()
    repeatOrderMeds.forEach((item) => {
        let haveCartIndex = cartItems.findIndex((cartItem) =>
            cartItem['mmid'] == item['mmid'])
        if (haveCartIndex !== -1) cartItems[haveCartIndex] = item;
        else cartItems.unshift(item);
    })
    updateCartItemsToRedux(cartItems)
}

export function mergeRepeatOrderImagesWithCart(repeatOrderImages) {
    let cartImages = getCartImagesFromRedux()
    updateCartImagesToRedux([...repeatOrderImages, ...cartImages])
}

export function updateRepeatOrderData(repeatOrderData) {
    updateRepeatOrderDataToRedux({
        ...repeatOrderData,
        isRepeatOrder: true,
        poid: repeatOrderData['poid'] ?? 0,
        ooid: repeatOrderData['ooid'] ?? repeatOrderData['oid']
    })
}

export const getCartItemPrice = (item) => {
    if (item?.mmid) {
        return Math.round((item.mrp.price) * item.quantity * 100) / 100
    } else return item.quantity * (item?.offerValue ?? 0)
}

export const upsertCartItem = (isAdd, item, quantity,
    { addItemToCartCallback = null, removeItemFromCartCallback = null, typedQuantity = false }) => {
    if (isAdd) {
        if (item?.quantity >= 9999) return
        vibrateDevice()
        if (item?.quantity && item?.quantity > 0)
            upsertCartItemToRedux(item, item.quantity + quantity);
        else {
            getCartTotalItemCount() ? null :
                trackMoengageEvents(MoengageEvents.cart_created)
            if (!typedQuantity) {
                let su = item?.su ?? item?.mrp?.su ?? 1
                quantity = quantity * su
            }
            upsertCartItemToRedux(item, quantity)
        }
        if (addItemToCartCallback)
            addItemToCartCallback(item, quantity)
    } else {
        vibrateDevice()
        if (item.quantity === 1) {
            if (getCartTotalItemCount() === 1 && removeItemFromCartCallback) {
                removeItemFromCartCallback(item);
            } else upsertCartItemToRedux(item, 0, true)
        } else upsertCartItemToRedux(item, item.quantity - quantity)
    }
}